function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        document.querySelector('.header-wrapper').classList.add('menu-open');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
      document.querySelector('.header-wrapper').classList.add('menu-open');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove('menu-opening');
      document.querySelector('.header-wrapper').classList.remove('menu-open');
      document.querySelector('.header-wrapper').classList.add('menu-closing');
      this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
        details.removeAttribute('open');
        details.classList.remove('menu-opening');
      });
      document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    document.querySelector('.header-wrapper').classList.remove('menu-open');
    document.querySelector('.header-wrapper').classList.add('menu-closing');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

    document.querySelector('.header-wrapper').classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent() {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.pageCount = this.querySelector('.slider-counter--current');
    this.pageTotal = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
    if (sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  update() {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.currentPage === this.totalPages) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages;
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + this.sliderLastItem.clientWidth : this.slider.scrollLeft - this.sliderLastItem.clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    if (!newMedia) return;
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    const parent = newMedia.parentElement;
    if (parent.firstChild == newMedia) return;
    modalContent.prepend(newMediaModal);
    parent.prepend(newMedia);
    this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
    if(this.stickyHeader) {
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }
    window.setTimeout(() => {
      parent.scrollLeft = 0;
      parent.querySelector('li.product__media-item').scrollIntoView({behavior: 'smooth'});
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);

        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > .product-form__submit-text');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);




$(document).ready(function () {

  console.log('Custom Shopify theme development by Sarah Holden:');
  console.log('https://saraheholden.com/');
  console.log('---');
  console.log('Design by Kati Forner Design:');
  console.log('https://katiforner.com/');

  $('.header summary').on('click', function () {
    if ($(window).innerWidth <= 750) {
      if ($(this).closest('details').attr('open')) {
        $('.header-wrapper').removeClass('submenu-open');
        $('body').removeClass('has-open-search overflow-hidden-tablet');
      } else {
        $('.header-wrapper').addClass('submenu-open');
      }
    }

  });

  $('.header-wrapper').on('mouseenter', function () {
    $(this).addClass('submenu-open');
    $('body').removeClass('has-open-search overflow-hidden-tablet');
  });

  $('.header-wrapper').on('mouseleave', function () {
    $(this).removeClass('submenu-open');
  });

  $('summary.header__menu-item').on('click', function (e) {
    e.preventDefault();
    $('body').removeClass('has-open-search overflow-hidden-tablet');
  });


  $('.header__heading-link, .header__logo-link').on('mouseenter', function () {
    $('details').prop('open', false);
  });

  $('summary.header__menu-item').on('mouseenter', function (e) {
    $('details').prop('open', false);
    $(this).closest('details').prop('open', true);
    $(this).closest('details').find('.header__submenu-image').hide();
    $(this).closest('details').find('.header__submenu-image').eq(0).fadeIn();
  });

  $('.header').on('mouseleave', function (e) {
    $('details').prop('open', false);
  });

  $('.header__submenu .header__menu-item').hover(function () {
    $(this).closest('ul').find('.header__menu-item').stop().css('opacity', .5);
    $(this).stop().css('opacity', 1);
    const imageKey = $(this).attr('data-image-key');
    $(`.header__submenu-image[data-image-key="${imageKey}"]`).siblings('.header__submenu-image').stop().hide();
    $(`.header__submenu-image[data-image-key="${imageKey}"]`).fadeIn();
  }, function () {
    $(this).closest('ul').find('.header__menu-item').css('opacity', 1);
  });

  $('.js-toggle-search').on('click', function (e) {
    e.preventDefault();
    if ($('body').hasClass('has-open-search')) {
      $('body').removeClass('has-open-search overflow-hidden-tablet');
    } else {
      $('body').addClass('has-open-search overflow-hidden-tablet');
    }

    $('body').on('click.closeSearch', function (e) {
      // debugger;
      if ($(e.target).closest('.search-modal').length == 0 && $(e.target).closest('.header__search').length == 0) {
        $('body').removeClass('has-open-search overflow-hidden-tablet');
        $('body').off('click.closeSearch');

      }
    });
  });

  $('.search__input').on('change, keyup', function () {
    // debugger;
    if ($(this).val().length > 0) {
      $(this).closest('form').find('.search__button').prop('disabled', false);
    } else {
      $(this).closest('form').find('.search__button').prop('disabled', true);
    }

  });

  /* ---------------------------------------------
  VIEW CART
  ------------------------------------------------ */
  // This store's sliding cart is Rebuy Smart Cart. The theme's own drawer was
  // retired: theme.liquid still renders a section named cart-drawer, but the
  // file behind it is now cart-drawer-back.liquid, so nothing renders and
  // section-cart.css no longer loads. Cancelling the click and adding
  // open-cart therefore did nothing at all, which is where the dead and rage
  // clicks on the cart icon came from. Open Rebuy when it is there, fall back
  // to the theme drawer on any page that still renders one, and otherwise
  // leave the click alone so the link follows its href to the cart page.
  // The rule is: never cancel the click without opening something.
  $('.js-view-cart').on('click', function(e) {
    try {
      var R = window.Rebuy;
      if (R && R.SmartCart && typeof R.SmartCart.show === 'function') {
        e.preventDefault();
        var show = function () { try { R.SmartCart.show(); } catch (err) {} };
        if (R.Cart && typeof R.Cart.fetchCart === 'function') {
          Promise.resolve(R.Cart.fetchCart()).then(show, show);
        } else { show(); }
        return;
      }
    } catch (err) {}
    if (document.querySelector('.cart-drawer')) {
      e.preventDefault();
      $('body').addClass('open-cart');
    }
  });

  $('.js-close-cart').on('click', function(e) {
    e.preventDefault();
    $('body').removeClass('open-cart');
  });

  $('.js-open-cart-notes').on('click', function (e) {
    e.preventDefault();
    $(this).closest('p').hide();
    $('.textarea-wrap').fadeIn();
  });

  $('#CartSpecialInstructions').on('blur', function (){
    CartJS.setNote($(this).val());
  });


  /* ---------------------------------------------
    CUSTOM PARALLAX & SCROLLING ZOOM EFFECTS
  ------------------------------------------------ */
  $('.js-animate-on-load').addClass('animate-in');

  gsap.registerPlugin(ScrollTrigger);

  // Set Defaults for ScrollTrigger (like showing markers for debugging)
  ScrollTrigger.defaults({
    markers: false,
  });

  /*** Different ScrollTrigger setups for various screen sizes (media queries) ***/
  ScrollTrigger.matchMedia({
    // desktop
    "(min-width: 1024px)": function() {
      gsap.utils.toArray('[data-from]').forEach((elem, i) => {
        const from = JSON.parse(elem.dataset.from);
        const to = JSON.parse(elem.dataset.to);
        const start = elem.dataset.start ? elem.dataset.start : "top bottom";
        const end = elem.dataset.end ? elem.dataset.end : "bottom top";

        let tl = gsap.timeline({
          scrollTrigger: {
             trigger: elem,
             scrub: true,
             start: start,
             end: end,
          }
        });

        // const vars = Object.assign(from, stObj);
        tl.fromTo(elem, from, to)
      });
    },

    // mobile
    "(max-width: 1024px)": function() {
      gsap.utils.toArray('[data-mobile-from]').forEach((elem, i) => {
        const from = JSON.parse(elem.dataset.mobileFrom);
        const to = JSON.parse(elem.dataset.mobileTo);
        const start = elem.dataset.start ? elem.dataset.start : "top bottom";
        const end = elem.dataset.end ? elem.dataset.end : "bottom top";

        let tl = gsap.timeline({
          scrollTrigger: {
             trigger: elem,
             scrub: true,
             start: start,
             end: end,
          }
        });

        // const vars = Object.assign(from, stObj);
        tl.fromTo(elem, from, to)
      });
    }
  });

  /* ---------------------------------------------
    ADD CLASS ON ENTRY
  ------------------------------------------------ */
  gsap.utils.toArray('.js-animate').forEach((elem, i) => {
    ScrollTrigger.create({
      trigger: elem,
      start: 'top 80%',
      onEnter: self => $(elem).addClass('animate-in')
    });
  });



  /* ---------------------------------------------
    STAGGER / BATCH ANIMATION
  ------------------------------------------------ */
  // Opacity set to 0 in CSS on load to avoid FOUC
  ScrollTrigger.batch('[data-stagger]', {
    onEnter: batch => gsap.to(batch, 1.35, {autoAlpha: 1, y: 0, stagger: 0.06, ease:Power1.easeOut}),
    start: "40px bottom",
  });

  ScrollTrigger.batch('[data-stagger-fast]', {
    onEnter: batch => gsap.to(batch, 1, {autoAlpha: 1, y: 0, stagger: 0.02, ease:Power1.easeOut}),
    start: "40px bottom",
  });

  /* ---------------------------------------------
    SPLIT TEXT
  ------------------------------------------------ */
  // Text animation helper function
  function triggerTextAnimation (delay, start, elem) {
    var tl = gsap.timeline({
      scrollTrigger: {
        trigger: elem,
        start: start
      }
    });

    const splitLineChild = new SplitText(elem, { type: "lines", linesClass: "split-line-child" });
    const splitTextLines = new SplitText(elem, { type: "lines", linesClass: "split-line-wrap-++" });

    tl.staggerFrom($(elem).find('.split-line-child'), 1.2, {y: '100%', ease: Power3.easeOut, delay: delay}, 0.15)
      .add( function () {
        splitTextLines.revert();
        splitLineChild.revert();
      });

  }


  document.fonts.ready.then(function () {

    $('[data-reveal="lines-masked"]').addClass('loaded');
    $('[data-reveal="lines-masked-desc"]').addClass('loaded');
    $('[data-reveal="words-masked"]').addClass('loaded');

    // REGULAR TEXT ANIMATION
    gsap.utils.toArray('[data-reveal="lines-masked"]').forEach((elem, i) => {
      const delay = elem.dataset.delay ? elem.dataset.delay : 0;
      const start = elem.dataset.start ? elem.dataset.start : "center bottom";
      triggerTextAnimation(delay, start, elem);
    });

    gsap.utils.toArray('[data-reveal="lines-masked-desc"]').forEach((elem, i) => {
      const delay = elem.dataset.delay ? elem.dataset.delay : 0;
      const start = elem.dataset.start ? elem.dataset.start : "center bottom";
      triggerTextAnimation(delay, start, $(elem).find('p'));
    });


    // WORDS POPPING UP FROM TILTED MASKS
    gsap.utils.toArray('[data-reveal="words-masked"]').forEach((elem, i) => {
      const start = elem.dataset.start ? elem.dataset.start : "top 80%";

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: elem,
          start: start
        }
      });

      var splitText = new SplitText($(elem).find('.animate-me'), { type: "lines,words", linesClass: "split-line-wrap", wordsClass: "split-line-child" });

      tl.staggerFrom($(elem).find('.split-line-child'), 1.4, {y: '100%', skewX: -15, rotate: 2, ease: Power4.easeOut}, .1);

      $(window).resize(function () {
        tl.progress(1);
        splitText.revert();
      });
    });


  });

    // WORDS SLIDING UP IN BLOCKS
    gsap.utils.toArray('[data-reveal="blocks-slide"]').forEach((elem, i) => {
      const start = elem.dataset.start ? elem.dataset.start : "top 80%";

      var tl = gsap.timeline({
        scrollTrigger: {
          trigger: elem,
          start: start
        }
      });

      tl.staggerFrom($(elem).find('.animate-me'), 1.4, {y: '200px', autoAlpha: 0, ease: Power4.easeOut}, .1);
    });

    /* ---------------------------------------------
    COOKIES
    ------------------------------------------------ */
    // GET COOKIE -------------
    function getCookie(name) {
      const dc = document.cookie;
      const prefix = `${name}=`;
      let begin = dc.indexOf(`; ${prefix}`);
      if (begin == -1) {
        begin = dc.indexOf(prefix);
        if (begin != 0) return null;
      } else {
        begin += 2;
        var end = document.cookie.indexOf(';', begin);
        if (end == -1) {
          end = dc.length;
        }
      }

      return decodeURI(dc.substring(begin + prefix.length, end));
    }

    // SET COOKIE -------------
    function setCookie (cookieName) {
      const date = new Date();
      const days = 30;

      // Get unix milliseconds at current time plus number of days
      date.setTime(+date + days * 86400000); // 24 * 60 * 60 * 1000
      window.document.cookie = `${cookieName +
        '=' +
        'no' +
        '; expires='}${date.toGMTString()}; path=/`;
    }

    // Get cookies on load;
    const hasAcceptedCookies = getCookie('accepts-cookies');

    // if (true) {
    if (hasAcceptedCookies === null) {
      $('body').addClass('show-gdpr-popup');
    }

    $('.js-close-cookies').on('click', function (e) {
      e.preventDefault();
      setCookie('accepts-cookies');
      $('body').removeClass('show-gdpr-popup');
    });


  // FORM SUBMIT =========================
  function validateEmail (email) {
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  // SUCCESS =========================
  function formSubmitted ($form) {
    // SHOW SUCCESS MESSAGE
    $form.closest('.js-outer-form-wrap').find('.js-inner-form-wrap').hide();
    $form.closest('.js-outer-form-wrap').find('.js-form-intro-wrap').hide();
    $form.closest('.js-outer-form-wrap').find('.success-message').fadeIn();

  }

  $('.js-klaviyo-form').on('submit', function (e) {
    e.preventDefault();
    var $form = $(this);
  	var email = $(this).find("input[type=email]").val();

    // CHECK FOR VALID EMAIL ADDRESS
    if (validateEmail(email)) {
      $($form).find('.error-message').fadeOut();

      var listId = $form.data('list-id');

      $.ajax({
        url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
        method: "POST",
        crossDomain: true,
        dataType: 'json',
        data: {
          "g": listId,
          '$consent': 'web',
          'email': email,
        },
        success: function (data) {
          formSubmitted($form);
        }
      });
    } else {
      $($form).find('.error-message').fadeIn();
    }
  });
  /* ---------------------------------------------
  SMOOTH SCROLL
  ------------------------------------------------ */
  $('.js-scroll-to').on('click', function(e) {
    e.preventDefault();

    var thisTarget = $(this).attr('href');

    if ($(thisTarget).length == 0) {
      return;
    }

    var targetOffset = $(thisTarget).offset().top;

    $('html, body').animate({
      scrollTop: targetOffset
    }, 600);
  });

  function externalLinks() {
    for(var c = document.getElementsByTagName("a"), a = 0;a < c.length;a++) {
      var b = c[a];
      b.getAttribute("href") && b.hostname !== location.hostname && (b.target = "_blank")
    }
  }
  ;
  externalLinks();


  $('.js-trigger-zendesk').on('click', function (e) {
    e.preventDefault();
    zE(function() {
      zE.activate();
    });
  })
});
